/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpLeftIcon20Regular = forwardRef('ArrowAUpLeftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.5 3.25a.75.75 0 0 1 0 1.5H5.81l10.72 10.72a.75.75 0 1 1-1.06 1.06L4.75 5.81v7.69a.75.75 0 0 1-1.5 0v-8A2.25 2.25 0 0 1 5.5 3.25h8Z" })));
});
